/**
 * Búsqueda Avanzada API Service
 * Búsqueda transversal de pacientes, órdenes y exámenes
 */

import { api } from "@/lib/api";

// =============================================================================
// TYPES
// =============================================================================

export interface BusquedaParams {
  identidad?: string;
  nombres?: string;
  apellidos?: string;
  numero_orden?: string;
  examen?: string;
  sucursal?: number;
  fecha_desde?: string; // YYYY-MM-DD
  fecha_hasta?: string; // YYYY-MM-DD
  page?: number;
  page_size?: number;
}

export interface BusquedaExamen {
  id: number;
  examen_nombre: string;
  examen_codigo: string;
  area: string;
  estado: string;
  precio: number;
}

export interface BusquedaOrden {
  id: number;
  numero: string;
  estado: string;
  fecha: string;
  sucursal_nombre: string;
  total_examenes: number;
  examenes: BusquedaExamen[];
}

export interface BusquedaResultado {
  id: number;
  nombre_completo: string;
  identificacion: string;
  num_documento: string;
  sexo: string;
  sexo_display: string;
  fecha_nacimiento: string;
  celular: string;
  total_ordenes: number;
  ordenes: BusquedaOrden[];
}

export interface BusquedaPaginada {
  count: number;
  next: string | null;
  previous: string | null;
  results: BusquedaResultado[];
}

// =============================================================================
// API
// =============================================================================

export async function buscar(
  params: BusquedaParams,
  signal?: AbortSignal
): Promise<BusquedaPaginada> {
  const searchParams = new URLSearchParams();
  Object.entries(params).forEach(([key, value]) => {
    if (value !== undefined && value !== "") {
      searchParams.append(key, String(value));
    }
  });
  const response = await api.get<BusquedaPaginada>(`/busqueda-avanzada/?${searchParams}`, {
    signal,
  });
  return response.data;
}
